import { environment } from '../environment/environment';

export interface CrmUser {
  Email: string;
  Name: string;
  Id: string;
}

/**
 * Search for CRM users by email or name
 * Uses raw fetch with inline mutation to match backend expectations
 */
export const searchAssignees = async (keyword: string): Promise<CrmUser[]> => {
  if (!keyword.trim()) {
    return [];
  }

  try {
    const query = `
      query {
        findCrmUsers(keyword: "${keyword}") {
          Count
          Data {
            Email
            Name
            Id
          }
        }
      }
    `;

    const token = localStorage.getItem('access_token');
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const response = await fetch(environment.graphqlEndpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({ query }),
    });

    const result = await response.json();

    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      return [];
    }

    return result.data?.findCrmUsers?.Data || [];
  } catch (error) {
    console.error('Error searching assignees:', error);
    return [];
  }
};
